import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { Provider } from "@redotech/redo-order-common/provider";

function getOrderSource(orderSources: Provider[]) {
  const allSame = orderSources.every((source) => source === orderSources[0]);

  if (!allSame) {
    return "Mixed";
  }

  if (orderSources[0] === Provider.SHOPIFY) {
    return "Shopify";
  }
  if (orderSources[0] === Provider.COMMERCE_CLOUD) {
    return "Commerce Cloud";
  }
  if (orderSources[0] === Provider.MANUAL) {
    return "Manual";
  }
  if (orderSources[0] === Provider.COMMENTSOLD) {
    return "Commentsold";
  }
  return "";
}

export const OrderSourceCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Order Source", cell: (row) => getOrderSource(row.orderSources) };
